import { getExportDisplayName } from ".";
import { Popup } from "../../../design_system/components/Popup/Popup.jsx";
import { AppliedFiltersPopupPanel } from "../reports/custom_reports/components/AppliedFiltersPopupPanel";
import { basic_filters_config } from "../../advanced_filters/config/basicFilterConfig";

const TREE_EXPORT_TYPES = ['NewLinkedinProspect', 'CustomReport']

const ExportAppliedTags = ({
    handleOnClosePopup,
    data_export
}) => {
    const isTreeType = TREE_EXPORT_TYPES.includes(data_export.type)
    const qbTree = data_export.qb_tree ? (typeof data_export.qb_tree === 'string' ? JSON.parse(data_export.qb_tree) : data_export.qb_tree) : null

    return (
        <Popup name={getExportDisplayName(data_export)} handleOnClosePopup={handleOnClosePopup} showHeaderDivider={false} maxWidth={560} customContentStyle={{ padding: 0 }} customHeaderStyle={{ paddingBottom: 4 }}>
            <div className="px-xl">
                <div className="body-s-semibold color-text-secondary">exported on {data_export.created_time}</div>
            </div>
            <div className="divider mt-s" />
            <div className="pt-m mb-xl">
                {isTreeType && qbTree ? (
                    <AppliedFiltersPopupPanel tree={qbTree} config={basic_filters_config} />
                ) : (
                    data_export.tags?.length > 0 && (
                        <div>
                            <div className="px-xl body-s-semibold color-text-secondary mb-s">Tags</div>
                            <div className="data-exports__tag-list px-xl">
                                {data_export.tags.map((tag, index) => (
                                    <div key={index} className="data-exports__tag-badge body-s-bold">
                                        <span className="data-exports__tag-badge-label">{tag.label}</span>
                                        <span className="color-text-secondary"> = </span>
                                        <span className="color-text-secondary">{tag.value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                )}
            </div>
        </Popup>
    )
}
export default ExportAppliedTags
